import mitt from 'mitt';
import { btnTd } from '@/api/typing';
import defaultSlotList from '@/components/page-model/slotList';
import { message, Modal, notification } from 'ant-design-vue';
import {
  get_s_product,
  create_productinrecord,
  update_productinrecord,
  remove_productinrecord,
  create_product_in_cancel_record,
  create_product_out_record,
  get_product_in_record,
} from '@/api/mjstock-model';
import { reactive, ref } from 'vue';
import modalBox from '@/components/form-modal/modal-tools';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY, STORAGE_CURRENT_SHOP_KEY } from '@/store/mutation-type';
import base_info from '@/components/info-modal/base_info_modal';
import moment from 'moment';

export const event_obj = mitt();
const field_disable_hd = ref(true);
const field_disable_to_shop = ref(true);
export const btn_list = [
  {
    name: '出库',
    type: 'dropdown',
    clazz: 'primary',
    is_show: (record: any) => {
      return record.is_active;
    },
    cb: (record: any) => {
      // 模态框，确认按钮点击。
      const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
      const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY); // 当前门店
      const editModal = reactive({
        visible: true,
        loading: false,
        title: '创建出库记录',
        form: {
          settings: {
            labelAlign: 'right',
            layout: 'horizontal',
            col: [8, 8],
          },
          fields: [
            {
              type: 'select',
              name: 'out_type',
              label: '出库类型',
              disabled: false,
              placeholder: '请选择出库类型',
              mode: 'default',
              allowClear: true,
            },
            {
              type: 'remoteselect',
              name: 'order_used_record_id',
              label: '耗单单据',
              disabled: field_disable_hd,
              placeholder: '请选择耗单单据',
              datasourceType: 'remote',
              mode: 'default',
              labelKey: 'order_code',
              init_model: { p_type: [0, 10, 20], is_delete: false, shop_id: current_shop?.id },
              field_status: { shop_id: current_shop ? 0 : 2 },
              allowClear: true,
              modalType: 'mjstore-orderusedrecord',
              btnIconName: 'SelectOutlined',
              cb: () => {
                return new Promise((resolve, reject) => {
                  const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
                  const modifyModal: any = reactive({
                    visible: true,
                    title: '选择耗单',
                    component: 'SelectMjstoreOrderusedrecord',
                    mode: 'default',
                    init_model: { date: moment().format('YYYY-MM-DD'), shop_id: current_shop?.id },
                    field_status: { shop_id: 0 },
                    obj: {
                      org_id: current_org?.id,
                      name: '',
                      price: '',
                      project_type_id: '',
                      card_ids: [],
                      project_ids: [],
                    },
                  });
                  modifyModal.visible = true;
                  modifyModal.ok = (data: any) => {
                    if (data == undefined) {
                      reject();
                    } else {
                      resolve(data);
                    }
                  };
                  modifyModal.cancel = () => {};
                  modalBox(modifyModal);
                });
              },
            },
            {
              type: 'remotemodal',
              name: 'product_in_record_id',
              label: '关联入库单据',
              disabled: true,
              placeholder: '请选择关联入库单据',
              datasourceType: 'remote',
              labelKey: 'code',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstock-productinrecord',
            },
            {
              type: 'input',
              name: 's_product__code',
              label: '存货编号',
              disabled: true,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
            },
            {
              type: 'input',
              name: 's_product__name',
              label: '存货名称',
              disabled: true,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
            },
            {
              type: 'input',
              name: 's_product__gg',
              label: '存货规格',
              disabled: true,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
            },
            {
              type: 'input',
              name: 's_product__dw',
              label: '存货单位',
              disabled: true,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
            },
            {
              type: 'input',
              name: 'position',
              label: '库位',
              disabled: true,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
            },

            {
              type: 'input',
              name: 'remain_num',
              label: '存货余量',
              disabled: true,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
            },
            {
              type: 'input',
              name: 'out_num',
              label: '出库数量',
              disabled: false,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
            },
            {
              type: 'input',
              name: 'single_price',
              label: '存货单价',
              disabled: true,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
            },
            {
              type: 'input',
              name: 'price',
              label: '存货金额',
              disabled: true,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
            },
            {
              type: 'remotemodal',
              name: 'to_shop_id',
              label: '出库去向',
              disabled: field_disable_to_shop,
              placeholder: '请选择出库去向',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-shop',
            },
            {
              type: 'datepicker',
              name: 'out_datetime',
              label: '出库日期',
              disabled: false,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
              showTime: true,
              placeholder: '请填写出库日期',
            },

            {
              type: 'remoteselect',
              name: 'shop_id',
              label: '执行门店',
              disabled: true,
              placeholder: '请选择执行门店',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-shop',
            },
            {
              type: 'remoteselect',
              name: 'staff_id',
              label: '执行人',
              disabled: false,
              placeholder: '请选择执行人',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-staff',
            },
          ],
          rules: {
            out_type: [{ required: true, message: '请选择出库类型' }],
            out_num: [{ required: true, message: '请输入出库数量' }],
            out_datetime: [{ required: true, message: '请选择入库日期' }],
            shop_id: [{ required: true, message: '请选择执行门店' }],
            staff_id: [{ required: true, message: '请选择执行人' }],
          },
          model: reactive({
            org_id: current_org?.id,
            product_in_record_id: record.id,
            out_num: 0,
            ...record,
            staff_id: null,
          }),
          watch: {
            out_type: (data: any) => {
              if (data.out_type == 1) {
                field_disable_hd.value = false;
                field_disable_to_shop.value = true;
                data.to_shop_id = null;
              } else if (data.out_type == 2) {
                field_disable_hd.value = true;
                field_disable_to_shop.value = true;
                data.to_shop_id = null;
                data.order_used_record_id = undefined;
              } else if (data.out_type == 3) {
                field_disable_hd.value = true;
                field_disable_to_shop.value = false;
                data.order_used_record_id = null;
              } else if (data.out_type == 4) {
                field_disable_hd.value = true;
                field_disable_to_shop.value = true;
                data.to_shop_id = null;
                data.order_used_record_id = null;
              } else if (data.out_type == 5) {
                field_disable_hd.value = true;
                field_disable_to_shop.value = true;
                data.to_shop_id = null;
                data.order_used_record_id = null;
              } else if (data.out_type == 6) {
                field_disable_hd.value = true;
                field_disable_to_shop.value = true;
                data.to_shop_id = null;
                data.order_used_record_id = null;
              }
            },
            out_num: (data: any) => {
              data.price = data.single_price * data.out_num;
            },
          },
        },
        options: {
          out_type: [
            { value: 1, label: '销售出库' },
            { value: 2, label: '盘亏出库' },
            { value: 3, label: '调拨出库' },
            { value: 4, label: '员工福利' },
            { value: 5, label: '客户试用' },
            { value: 6, label: '其他出库' },
          ],
        },
        ok: (payload: any) => {
          if (Number(payload.out_num) <= 0) {
            notification.error({
              message: '输入数值错误',
              description: '出库数量要大于0',
            });
            return false;
          }
          return new Promise(resolve => {
            editModal.loading = true;
            create_product_out_record(payload)
              .then(() => {
                message.success('出库记录创建成功');
                event_obj.emit('refresh');
                resolve(null);
              })
              .finally(() => {
                editModal.loading = false;
              });
          });
        },
      });
      modalBox(editModal);
    },
  },
  {
    name: '编辑',
    type: 'dropdown',
    clazz: 'primary',
    is_show: (record: any) => {
      return record.is_active;
    },
    cb: (record: any) => {
      const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
      const loading = ref(false);
      const editModal = reactive({
        visible: true,
        title: '修改入库信息',
        form: {
          settings: {
            labelAlign: 'right',
            layout: 'horizontal',
            col: [7, 6],
          },
          fields: [
            {
              type: 'input',
              name: 'code',
              label: '入库单编号',
              disabled: true,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
            },
            {
              type: 'input',
              name: 's_product__code',
              label: '存货编号',
              disabled: true,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
            },
            {
              type: 'input',
              name: 's_product__name',
              label: '存货名称',
              disabled: true,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
            },
            {
              type: 'input',
              name: 's_product__gg',
              label: '存货规格',
              disabled: true,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
            },
            {
              type: 'input',
              name: 's_product__dw',
              label: '存货单位',
              disabled: true,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
            },
            {
              type: 'input',
              name: 'position',
              label: '库位',
              disabled: true,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
            },
            {
              type: 'input',
              name: 'in_num',
              label: '存货数量',
              disabled: true,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
            },
            {
              type: 'input',
              name: 'single_price',
              label: '存货单价',
              disabled: true,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
            },
            {
              type: 'input',
              name: 'price',
              label: '存货金额',
              disabled: false,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
            },
            {
              type: 'datepicker',
              name: 'product_date',
              label: '生产日期',
              disabled: false,
              allowClear: true,
              inputType: 'number',
              format: 'YYYY-MM-DD',
              valueFormat: 'YYYY-MM-DD',
              defaultValue: '',
              showTime: false,
              placeholder: '请填写生产日期',
            },
            {
              type: 'datepicker',
              name: 'end_date',
              label: '到期日期',
              disabled: false,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
              format: 'YYYY-MM-DD',
              valueFormat: 'YYYY-MM-DD',
              showTime: false,
              placeholder: '请填写到期日期',
            },
            {
              type: 'remotemodal',
              name: 'supply_company_id',
              label: '供应商',
              disabled: false,
              placeholder: '请选择供应商',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstock-supplycompany',
            },
            {
              type: 'remotemodal',
              name: 'product_company_id',
              label: '厂商',
              disabled: false,
              placeholder: '请选择厂商',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstock-productcompany',
            },
          ],
          rules: {},
          model: reactive({
            org_id: current_org?.id,
            ...record,
          }),
          watch: {
            price: (data: any) => {
              const price: number = data.price;
              data['single_price'] = price / data.in_num;
            },
          },
        },
        options: {},
        loading: loading,
        ok: (payload: any) => {
          return new Promise(resolve => {
            loading.value = true;
            payload['product_in_record_id'] = record.id;
            update_productinrecord(payload)
              .then(() => {
                message.success('入库记录修改成功');
                event_obj.emit('refresh');
                resolve(null);
              })
              .finally(() => {
                loading.value = false;
              });
          });
        },
      });
      modalBox(editModal);
    },
  },
  {
    name: '作废',
    type: 'dropdown',
    clazz: 'danger',
    is_show: (record: any) => {
      return record.is_active && record.in_type != 3;
    },
    cb: (record: any) => {
      const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
      Modal.confirm({
        title: '提示',
        content: '是否作废这条记录[' + record.code + ']',
        onOk() {
          remove_productinrecord({
            product_in_record_id: record.id,
            org_id: current_org?.id,
          }).then(function (res) {
            message.success('作废成功');
            Object.assign(record, res);
          });
        },
        onCancel() {},
      });
    },
  },
  {
    name: '入库退货',
    type: 'dropdown',
    clazz: '',
    is_show: (record: any) => {
      return record.is_active;
    },
    cb: (record: any) => {
      // 模态框，确认按钮点击。
      const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
      const editModal = reactive({
        visible: true,
        loading: false,
        title: '创建入库退货记录',
        form: {
          settings: {
            labelAlign: 'right',
            layout: 'horizontal',
            col: [8, 8],
          },
          fields: [
            {
              type: 'remotemodal',
              name: 'product_in_record_id',
              label: '关联入库单据',
              disabled: true,
              placeholder: '请选择关联入库单据',
              datasourceType: 'remote',
              labelKey: 'code',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstock-productinrecord',
            },
            {
              type: 'input',
              name: 's_product__code',
              label: '存货编号',
              disabled: true,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
            },
            {
              type: 'input',
              name: 's_product__name',
              label: '存货名称',
              disabled: true,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
            },
            {
              type: 'input',
              name: 's_product__gg',
              label: '存货规格',
              disabled: true,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
            },
            {
              type: 'input',
              name: 's_product__dw',
              label: '存货单位',
              disabled: true,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
            },
            {
              type: 'input',
              name: 'position',
              label: '库位',
              disabled: true,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
            },
            {
              type: 'input',
              name: 'remain_num',
              label: '存货余量',
              disabled: true,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
            },
            {
              type: 'input',
              name: 'cancel_num',
              label: '退货数量',
              disabled: false,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
            },
            {
              type: 'input',
              name: 'single_price',
              label: '存货单价',
              disabled: true,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
            },
            {
              type: 'input',
              name: 'cancel_price',
              label: '退货金额',
              disabled: true,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
            },
            {
              type: 'remotemodal',
              name: 'from_shop_id',
              label: '调拨来源',
              disabled: true,
              placeholder: '请选择调拨来源',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-shop',
            },
            {
              type: 'remotemodal',
              name: 'transfer_code',
              label: '调拨编号',
              disabled: true,
              placeholder: '请选择调拨来源',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-shop',
            },
            {
              type: 'datepicker',
              name: 'cancel_datetime',
              label: '退货日期',
              disabled: false,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
              showTime: true,
              placeholder: '请填写出库日期',
            },
            {
              type: 'remoteselect',
              name: 'shop_id',
              label: '执行门店',
              disabled: true,
              placeholder: '请选择执行门店',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-shop',
            },
            {
              type: 'remoteselect',
              name: 'staff_id',
              label: '执行人',
              disabled: false,
              placeholder: '请选择执行人',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-staff',
            },
            {
              type: 'input',
              name: 'cancel_reason',
              label: '退库原因',
              disabled: false,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
            },
          ],
          rules: {
            cancel_num: [{ required: true, message: '请输入退货数量' }],
            product_in_record_id: [{ required: true, message: '请选择关联入库单据' }],
            cancel_datetime: [{ required: true, message: '请选择退货日期' }],
            staff_id: [{ required: true, message: '请选择执行人' }],
            cancel_reason: [{ required: true, message: '请填写退库原因' }],
          },
          model: reactive({
            org_id: current_org?.id,
            product_in_record_id: record.id,
            ...record,
            staff_id: null,
          }),
          watch: {
            cancel_num: (data: any) => {
              data.cancel_price = data.single_price * data.cancel_num;
            },
          },
        },
        options: {},
        ok: (payload: any) => {
          if (Number(payload.cancel_num) <= 0 && Number(payload.cancel_num) > payload.remain_num) {
            notification.error({
              message: '输入数值错误',
              description: '退货数量要大于0,且小于余次数量',
            });
            return false;
          }
          return new Promise(resolve => {
            editModal.loading = true;
            create_product_in_cancel_record(payload)
              .then(() => {
                message.success('出库记录创建成功');
                event_obj.emit('refresh');
                resolve(null);
              })
              .finally(() => {
                editModal.loading = false;
              });
          });
        },
      });
      modalBox(editModal);
    },
  },
  {
    name: '详情',
    type: 'dropdown',
    clazz: '',
    is_show: (record: any) => {
      return record.is_active;
    },
    cb: (record: any) => {
      // 模态框，确认按钮点击。
      const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
      get_product_in_record({ org_id: current_org?.id, product_in_record_id: record.id }).then(
        function (res: any) {
          base_info(
            '入库产品信息',
            '入库编号:' + res.code,
            [
              { name: '存货编号', value: 's_product__code' },
              { name: '存货名称', value: 's_product__name' },
              { name: '存货规格', value: 's_product__gg' },
              { name: '存货单位', value: 's_product__dw' },
              // { name: '产品批次', value: 'product_code' },
              { name: '存货单价', value: 'single_price' },
              { name: '生产日期', value: 'product_date' },
              { name: '到期日期', value: 'end_date' },
              { name: '厂商', value: 'product_company__name' },
              { name: '供货商', value: 'supply_company__name' },
            ],
            res,
          );
        },
      );
    },
  },
];
export const slotList = defaultSlotList;
export const config = {
  creatCol: [],
  updateCol: [],
};

const in_type = 1; // 采购入库
const title = '新建入库'; // 采购入库

export const head_btn_list: btnTd[] = [
  {
    name: title,
    clazz: 'primary',
    cb: () => {
      // 模态框，确认按钮点击。
      const current_shop = ls.get(STORAGE_CURRENT_SHOP_KEY); // 当前门店
      const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
      const editModal = reactive({
        visible: true,
        loading: false,
        title: title,
        form: {
          settings: {
            labelAlign: 'right',
            layout: 'horizontal',
            col: [8, 8],
          },
          fields: [
            {
              type: 'select',
              name: 'in_type',
              label: '入库类型',
              disabled: false,
              placeholder: '请选择入库类型',
              mode: 'default',
              allowClear: true,
            },
            {
              type: 'remotemodal',
              name: 's_product_id',
              label: '存货名称',
              disabled: false,
              placeholder: '请选择存货名称',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstock-sproduct',
            },
            {
              type: 'input',
              name: 's_product__code',
              label: '存货编号',
              disabled: true,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
            },
            {
              type: 'input',
              name: 's_product__gg',
              label: '存货规格',
              disabled: true,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
            },
            {
              type: 'input',
              name: 's_product__dw',
              label: '存货单位',
              disabled: true,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
            },
            {
              type: 'input',
              name: 'position',
              label: '库位',
              disabled: false,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
            },
            {
              type: 'input',
              name: 'in_num',
              label: '存货数量',
              disabled: false,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
            },
            {
              type: 'input',
              name: 'single_price',
              label: '存货单价',
              disabled: true,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
            },
            {
              type: 'input',
              name: 'price',
              label: '存货金额',
              disabled: false,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
            },
            {
              type: 'datepicker',
              name: 'product_date',
              label: '生产日期',
              disabled: false,
              allowClear: true,
              inputType: 'number',
              format: 'YYYY-MM-DD',
              valueFormat: 'YYYY-MM-DD',
              defaultValue: '',
              showTime: false,
              placeholder: '请填写生产日期',
            },
            {
              type: 'datepicker',
              name: 'end_date',
              label: '到期日期',
              disabled: false,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
              format: 'YYYY-MM-DD',
              valueFormat: 'YYYY-MM-DD',
              showTime: false,
              placeholder: '请填写到期日期',
            },
            {
              type: 'remotemodal',
              name: 'supply_company_id',
              label: '供应商',
              disabled: false,
              placeholder: '请选择供应商',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstock-supplycompany',
            },
            {
              type: 'remotemodal',
              name: 'product_company_id',
              label: '厂商',
              disabled: false,
              placeholder: '请选择厂商',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstock-productcompany',
            },
            {
              type: 'datepicker',
              name: 'in_datetime',
              label: '入库日期',
              disabled: false,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
              showTime: true,
              placeholder: '请填写入库日期',
            },

            {
              type: 'remoteselect',
              name: 'shop_id',
              label: '执行门店',
              disabled: !!current_shop,
              placeholder: '请选择执行门店',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-shop',
            },
            {
              type: 'remoteselect',
              name: 'staff_id',
              label: '执行人',
              disabled: false,
              placeholder: '请选择执行人',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-staff',
            },
          ],
          rules: {
            in_type: [{ required: true, message: '请选择入库类型' }],
            in_num: [{ required: true, message: '请输入存货数量' }],
            price: [{ required: true, message: '请输入存货单价' }],
            s_product_id: [{ required: true, message: '请选择存货名称' }],
            in_datetime: [{ required: true, message: '请选择入库日期' }],
            product_date: [{ required: true, message: '请选择生产日期' }],
            end_date: [{ required: true, message: '请选择到期日期' }],
            shop_id: [{ required: true, message: '请选择执行门店' }],
            product_company_id: [{ required: true, message: '请选择厂商' }],
            supply_company_id: [{ required: true, message: '请选择供应商' }],
            staff_id: [{ required: true, message: '请选择执行人' }],
          },
          model: reactive({
            org_id: current_org?.id,
            in_type: in_type,
            s_product__code: '',
            s_product__gg: '',
            s_product__dw: '',
            single_price: 0,
            price: 0,
            shop_id: current_shop?.id,
            in_num: 0,
          }),
          watch: {
            s_product_id: (data: any) => {
              if (data.s_product_id && data.s_product_id > 0) {
                get_s_product({ org_id: current_org?.id, s_product_id: data.s_product_id }).then(
                  function (res: any) {
                    data.s_product__code = res.code;
                    data.s_product__gg = res.gg;
                    data.s_product__dw = res.dw;
                  },
                );
              }
            },
            price: (data: any) => {
              const price: number = data.price;
              data['single_price'] = price / data.in_num;
            },
            in_num: (data: any) => {
              const price: number = data.price;
              data['single_price'] = price / data.in_num;
            },
          },
        },
        options: {
          in_type: [
            { label: '采购入库', value: 1 },
            { label: '盘盈入库', value: 2 },
            { label: '其他入库', value: 4 },
          ],
        },
        ok: (payload: any) => {
          if (Number(payload.in_num) <= 0) {
            notification.error({
              message: '输入数值错误',
              description: '入库数量要大于0',
            });
            return false;
          }
          return new Promise(resolve => {
            editModal.loading = true;
            create_productinrecord(payload)
              .then(() => {
                message.success('入库记录创建成功');
                event_obj.emit('refresh');
                resolve(null);
              })
              .finally(() => {
                editModal.loading = false;
              });
          });
        },
      });
      modalBox(editModal);
    },
  },
];
